import {
  SET_KANBAN_UI_FLAG,
  CLEAR_KANBANS,
  SET_KANBANS,
  SET_KANBAN_ITEM,
  EDIT_KANBAN,
  DELETE_KANBAN,
  SET_KANBAN_STAGE,
  DELETE_KANBAN_STAGE,
  SET_KANBAN_STAGE_AUTOMATION,
} from './types';

export const mutations = {
  [SET_KANBAN_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [CLEAR_KANBANS]: $state => {
    $state.records = {};
  },

  [SET_KANBANS]: ($state, data) => {
    const updatedRecords = { ...$state.records };
    data.forEach(kanban => {
      updatedRecords[kanban.id] = {
        ...(updatedRecords[kanban.id] || {}),
        ...kanban,
      };
    });
    $state.records = updatedRecords;
  },

  [SET_KANBAN_ITEM]: ($state, data) => {
    $state.records = {
      ...$state.records,
      [data.id]: {
        ...($state.records[data.id] || {}),
        ...data,
      },
    };
  },

  [EDIT_KANBAN]: ($state, data) => {
    $state.records = {
      ...$state.records,
      [data.id]: {
        ...($state.records[data.id] || {}),
        ...data,
      },
    };
  },

  [DELETE_KANBAN]: ($state, kanbanId) => {
    const { [kanbanId]: toDelete, ...records } = $state.records;
    $state.records = records;
  },

  [SET_KANBAN_STAGE]: ($state, { kanbanId, stage }) => {
    const kanban = $state.records[kanbanId];
    if (!kanban) return;

    const stages = [...(kanban.kanban_stages || [])];
    const existingIndex = stages.findIndex(s => s.id === stage.id);
    if (existingIndex !== -1) {
      stages[existingIndex] = stage;
    } else {
      stages.push(stage);
    }

    $state.records = {
      ...$state.records,
      [kanbanId]: { ...kanban, kanban_stages: stages },
    };
  },

  [DELETE_KANBAN_STAGE]: ($state, { kanbanId, id }) => {
    const kanban = $state.records[kanbanId];
    if (!kanban) return;

    $state.records = {
      ...$state.records,
      [kanbanId]: {
        ...kanban,
        kanban_stages: (kanban.kanban_stages || []).filter(s => s.id !== id),
      },
    };
  },

  [SET_KANBAN_STAGE_AUTOMATION]: ($state, { stageId, automation }) => {
    $state.automations = {
      ...$state.automations,
      [stageId]: automation,
    };
  },
};
